import { connect } from 'react-redux';
import { Authentication } from '../../components/Authentication';

function mapStateToProps(state) {
  return {
    activeView: state.view.active
  };
}

export var AuthenticationContainer = connect(mapStateToProps)(Authentication);